<template>
  <Dialog
    :visible="visible"
    :title="kind === 'off' ? $t(`${namespace}.off.title`) : $t(`${namespace}.on.title`)"
    max-width="638"
    @close="close(true)"
  >
    <div>

      <v-card-text class="dialog__body">
        <span v-if="kind === 'off'" v-html="$t(`${namespace}.off.text`)" class="gray-6--text" />
        <span v-if="kind === 'on'" v-html="$t(`${namespace}.on.text`)" class="gray-6--text" />
      </v-card-text>

      <v-divider />

      <v-card-actions class="dialog__footer">
        <v-spacer/>

        <a
          class="mr-4"
          @click.prevent="close(true)"
        >
          {{ $t(`${namespace}.cancel`) }}
        </a>

        <Button @click="handleConfirmChange">
          {{ $t(`${namespace}.proceed`) }}
        </Button>
      </v-card-actions>
    </div>
  </Dialog>
</template>

<script>
export default {
  name: 'FlexibleBenefitConfirmDialog',
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    kind: {
      type: String,
      default: 'on'
    }
  },
  data () {
    return {
      namespace: 'Components.FlexibleBenefitConfirmDialog'
    }
  },
  methods: {
    close (reset = null) {
      if (this.kind === 'on' && reset) {
        this.$emit('close', {
          reset: true,
          tab: null
        })
      }

      if (this.kind === 'off') {
        this.$emit('close', {
          reset: true,
          tab: 'creditPolicyTab2'
        })
      }
    },

    handleConfirmChange () {
      if (this.kind === 'on') {
        this.$emit('confirm', {
          reset: true,
          tab: 'creditPolicyTab2'
        })
      }

      if (this.kind === 'off') {
        this.$emit('confirm', {
          reset: true,
          tab: 'creditPolicyTab1'
        })
      }
    }
  }
}
</script>
